import { SQLService } from '../../../services/sql.service';
import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { Router,NavigationEnd,ActivatedRoute } from '@angular/router';
import { ModalController, NavParams } from '@ionic/angular';
import { Location } from '@angular/common';
@Component({
  selector: 'app-preview-payment',
  templateUrl: './preview-payment.component.html',
  styleUrls: ['./preview-payment.component.styl']
})
export class PreviewPaymentFieldsPage implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private params: NavParams,
    public sql: SQLService,
    private navCtrl: ModalController
  ) {
    this.payment = this.params.get('data');
    this.router.events.subscribe((eve) => {
    });
  }
  payment: any;
  ngOnInit() {
    this.payment = this.params.get('data');
  }
  off() {
    this.navCtrl.dismiss();
  }
}